module.exports = __webpack_public_path__ + "img/gate.3b9179ee.png";